import React from 'react';

import css from './WishlistHeart.module.css';

/**
 * Toggle control for a listing saved in the current user's wishlist.
 *
 * @param {object} props
 * @param {boolean} props.isSaved whether the listing is currently saved
 * @param {boolean} props.inProgress whether a wishlist update is pending
 * @param {Function} props.onToggle callback that persists the change
 * @returns {JSX.Element}
 */
const WishlistHeart = ({ className, isSaved, inProgress = false, onToggle }) => (
  <button
    type="button"
    className={`${css.root} ${isSaved ? css.selected : ''} ${className || ''}`}
    aria-label={isSaved ? 'Remove from Wishlist' : 'Add to Wishlist'}
    aria-pressed={isSaved}
    disabled={inProgress}
    onClick={event => {
      event.preventDefault();
      event.stopPropagation();
      onToggle();
    }}
  >
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 20.4 3.8 12.6A5.2 5.2 0 0 1 11.2 5l.8.8.8-.8a5.2 5.2 0 0 1 7.4 7.6L12 20.4Z" />
    </svg>
  </button>
);

export default WishlistHeart;
